import AddressAutocomplete, { ISelectedAddressRecord } from "@mirage/components/addressBox/AddressAutocomplete";
import useSessionStorage from "@mirage/hooks/useSessionStorage";
import { Grid, TextField } from "@mui/material";
import { PPConstants } from "@shared/publicportal/constants";
import { PropertySearchFilter } from "@shared/publicportal/contracts/PropertySearchFilter";
import React from "react";

const PropertySearchFields: React.FC<{ state: PropertySearchFilter; setStateModifier: (modifier: Partial<PropertySearchFilter>) => void }> = ({ state, setStateModifier }) => {
    const handleGazetteerOnSelect = (props: ISelectedAddressRecord) => {
        setStateModifier({
            address: props.address,
            addressLine1: props.addressLines.line1,
            addressLine2: props.addressLines.line2,
            addressLine3: props.addressLines.line3,
            postTown: props.addressDetails.TOWN_NAME,
            postCode: props.addressDetails.POSTCODE,
            uprn: props.addressDetails.UPRN,
            easting: props.point?.easting,
            northing: props.point?.northing,
        });
    };
    const [sessionValue] = useSessionStorage(PPConstants.AppName);
    const { clientSettings } = sessionValue;

    return (
        <Grid container className="search-container propertySearch">
            <Grid container item xs={12}>
                <Grid item xs={12}>
                    <AddressAutocomplete
                        localGazetteerUrl={clientSettings?.LOCAL_GAZETTEER_URL as string}
                        localGazetteerToken={clientSettings?.LOCAL_GAZETTEER_TOKEN as string}
                        nationalGazetteerUrl={clientSettings?.NATIONAL_GAZETTEER_URL as string}
                        nationalGazetteerToken={clientSettings?.NATIONAL_GAZETTEER_TOKEN as string}
                        size="small"
                        gazetteer={"national"}
                        onSelect={handleGazetteerOnSelect}
                        gazetteerChoice
                    />
                </Grid>
            </Grid>
            <Grid container item columnGap={3}>
                <Grid container item xs={4}>
                    <Grid item xs={12}>
                        <TextField
                            disabled
                            name="address"
                            value={state.address || ""}
                            onChange={(event) => setStateModifier({ address: event.target.value })}
                            key="propertySearch-address-key"
                            size="small"
                            id="propertySearch-address"
                            label="Address"
                            variant="outlined"
                            className="min-width-18rem propertySearch__field"
                            multiline
                            rows={5}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            disabled
                            name="easting"
                            value={state.easting || ""}
                            onChange={(event) => setStateModifier({ easting: event.target.value })}
                            key="propertySearch-easting-key"
                            size="small"
                            id="propertySearch-easting"
                            label="Easting"
                            variant="outlined"
                            className="min-width-18rem propertySearch__field"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            disabled
                            name="northing"
                            value={state.northing || ""}
                            onChange={(event) => setStateModifier({ northing: event.target.value })}
                            key="propertySearch-northing-key"
                            size="small"
                            id="propertySearch-northing"
                            label="Northing"
                            variant="outlined"
                            className="min-width-18rem propertySearch__field"
                        />
                    </Grid>
                </Grid>
                <Grid container item xs={4} rowGap={3}>
                    <Grid item xs={12}>
                        <TextField
                            disabled
                            name="addressLine1"
                            value={state.addressLine1 || ""}
                            onChange={(event) => setStateModifier({ addressLine1: event.target.value })}
                            key="propertySearch-addressLine1-key"
                            size="small"
                            id="propertySearch-addressLine1"
                            label="Address Line 1"
                            variant="outlined"
                            className="min-width-18rem propertySearch__field"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            disabled
                            name="addressLine2"
                            value={state.addressLine2 || ""}
                            onChange={(event) => setStateModifier({ addressLine2: event.target.value })}
                            key="propertySearch-addressLine2-key"
                            size="small"
                            id="propertySearch-addressLine2"
                            label="Address Line 2"
                            variant="outlined"
                            className="min-width-18rem propertySearch__field"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            disabled
                            name="addressLine3"
                            value={state.addressLine3 || ""}
                            onChange={(event) => setStateModifier({ addressLine3: event.target.value })}
                            key="propertySearch-addressLine3-key"
                            size="small"
                            id="propertySearch-addressLine3"
                            label="Address Line 3"
                            variant="outlined"
                            className="min-width-18rem propertySearch__field"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            disabled
                            name="postTown"
                            value={state.postTown || ""}
                            onChange={(event) => setStateModifier({ postTown: event.target.value })}
                            key="propertySearch-postTown-key"
                            size="small"
                            id="propertySearch-postTown"
                            label="Post Town"
                            variant="outlined"
                            className="min-width-18rem propertySearch__field"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            disabled
                            name="postCode"
                            value={state.postCode || ""}
                            onChange={(event) => setStateModifier({ postCode: event.target.value })}
                            key="propertySearch-postCode-key"
                            size="small"
                            id="propertySearch-postCode"
                            label="Post Code"
                            variant="outlined"
                            className="min-width-18rem propertySearch__field"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            disabled
                            name="uprn"
                            value={state.uprn || ""}
                            onChange={(event) => setStateModifier({ uprn: event.target.value })}
                            key="propertySearch-uprn-key"
                            size="small"
                            id="propertySearch-uprn"
                            label="UPRN"
                            variant="outlined"
                            className="min-width-18rem propertySearch__field"
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default PropertySearchFields;
